module.exports = __webpack_public_path__ + "img/sms.8df5e25e.svg";